import type { FC } from "react";

import {
  MOBILE_OVERLAY_ROUTE_QUERY_PARAM,
  SECONDARY_OVERLAY_QUERY_PARAM,
  SecondaryOverlayType,
} from "components/constants";
import { CloseButton, CloseButtonProps } from "mds/components/CloseButton";
import { useQueryParamsActions } from "utils/routing";

type CloseOverlayButtonProps = Omit<CloseButtonProps<"button">, "onClick"> & {
  focusPanelTrigger?: SecondaryOverlayType;
};

export const CloseOverlayButton: FC<CloseOverlayButtonProps> = ({
  size = "s",
  focusPanelTrigger,
  ...props
}) => {
  const { deleteQueryParams } = useQueryParamsActions();

  const onClose = () => {
    deleteQueryParams([SECONDARY_OVERLAY_QUERY_PARAM, MOBILE_OVERLAY_ROUTE_QUERY_PARAM]);
    if (focusPanelTrigger) {
      // Focus the trigger button for the panel that was closed, so keyboard users can continue navigating.
      const triggerButton = document.querySelector<HTMLButtonElement>(
        `button[data-panel-trigger="${focusPanelTrigger}"]`,
      );
      triggerButton?.focus();
    }
  };

  return <CloseButton eventName="Right Panel - Close" size={size} {...props} onClick={onClose} />;
};
